module.exports = __webpack_public_path__ + "static/carnival.b72fc02e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/carnival.svg
// module id = 417
// module chunks = 59819425949494